import { create } from 'zustand';
import type { UserInfo } from '@/types/AceIdentity';

interface IdentityStore {
  userInfo?: UserInfo;
  setUserInfo: (userInfo: UserInfo) => void;
  clearUserInfo: () => void;
}

const useIdentityStore = create<IdentityStore>((set) => ({
  userInfo: undefined,
  setUserInfo: (userInfo) => set({ userInfo }),
  clearUserInfo: () => set({ userInfo: undefined }),
}));

export default useIdentityStore;
